import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Award, Target, Users, TrendingUp } from 'lucide-react';
import { certificationsData, serviceAreasData, aboutImages } from '../mockData';

export const AboutPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-cyan-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
              Sobre a Visiomed
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Desde 1991 oferecendo soluções técnicas para o setor de saúde
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg text-gray-600 leading-relaxed">
                A Visiomed Eletromedicina Ltda é uma empresa fundada em 1991, especializada em soluções técnicas para o setor de saúde. Com sede em Belo Horizonte, atua na manutenção preventiva e corretiva de equipamentos eletromédicos de diagnóstico por imagem, oferecendo serviços com qualidade, precisão e confiabilidade.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Além da assistência técnica, a empresa também realiza a comercialização e locação de equipamentos médico-hospitalares, atendendo hospitais, clínicas e instituições públicas e privadas. Com experiência consolidada, reputação comprovada e equipe técnica qualificada, a Visiomed tem como compromisso garantir segurança, eficiência operacional e continuidade dos serviços de saúde de seus clientes.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img 
                src={aboutImages.team} 
                alt="Equipe Médica"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-gray-50">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Nossos Valores Fundamentais
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-8 text-center space-y-4">
                <div className="mx-auto h-16 w-16 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Award className="text-blue-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Excelência</h3>
                <p className="text-gray-600">
                  Buscamos excelência em todos os aspectos da nossa prestação de serviços
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-8 text-center space-y-4">
                <div className="mx-auto h-16 w-16 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Target className="text-blue-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Confiabilidade</h3>
                <p className="text-gray-600">
                  Nossos clientes dependem de nós, e entregamos consistentemente
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-8 text-center space-y-4">
                <div className="mx-auto h-16 w-16 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Users className="text-blue-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Parceria</h3>
                <p className="text-gray-600">
                  Construímos relacionamentos de longo prazo com nossos clientes
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-8 text-center space-y-4">
                <div className="mx-auto h-16 w-16 bg-blue-100 rounded-lg flex items-center justify-center">
                  <TrendingUp className="text-blue-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900">Inovação</h3>
                <p className="text-gray-600">
                  Estamos sempre alinhados às mais modernas soluções em tecnologia médica
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

    </div>
  );
};